// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__MsE7Z","nav__link":"Navigation_nav__link__-JGkw","active":"Navigation_active__8X7xS","mobileNav":"Navigation_mobileNav__-iCCn"};